export interface PostImage {
  id: string;
  base64: string;
  caption?: string;
  alt?: string;
}

export interface PostContent {
  text: string; // Rich text HTML
  images: PostImage[];
}

export const createEmptyPostContent = (): PostContent => ({
  text: '',
  images: []
});

export const isPostContentJSON = (content: string): boolean => {
  try {
    const parsed = JSON.parse(content);
    return parsed && typeof parsed === 'object' && 'text' in parsed && 'images' in parsed;
  } catch {
    return false;
  }
};

export const parsePostContent = (content: string): PostContent => {
  if (isPostContentJSON(content)) {
    return JSON.parse(content);
  }
  // Legacy support: plain text or HTML
  return {
    text: content,
    images: []
  };
};